import React from 'react';
import { ErrorBoundaryFlag as ErrorBoundary } from '@atlassian/jira-error-boundary-flag-renderer/src/ErrorBoundaryFlag.tsx';
import { useIntl } from '@atlassian/jira-intl';
import MetaDate from '@atlassian/jira-issue-meta-date/src/main.tsx';
import messages from './messages.tsx';

type Props = {
	date: string;
};

export const UpdatedDate = ({ date }: Props): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	return date !== null && date !== '' ? (
		<ErrorBoundary>
			<MetaDate
				testId="updated-date.ui.read.meta-date"
				date={date}
				text={formatMessage(messages.updatedLabel)}
			/>
		</ErrorBoundary>
	) : null;
};
